import { j as p } from "../../../../node_modules/react/jsx-runtime.js";
import { useEffect as k, useState as V, useRef as x } from "react";
import { clsx as v } from "../../../../node_modules/clsx/dist/clsx.m.js";
import E from "../components/FieldHelperText/FieldHelperText.js";
import y from "./OtpInput.module.scss.js";
const K = (a, f) => {
  const [o, l] = V(Array(a).fill("")), u = x(Array(a).fill(null));
  k(() => {
    if (f) {
      const e = f.split("").slice(0, a);
      l([...e, ...Array(a - e.length).fill("")]);
    }
  }, [f, a]);
  const r = (e) => {
    var t;
    u.current[e] && ((t = u.current[e]) == null || t.focus());
  };
  return { values: o, refs: u, handleFocus: r, handleKeydown: (e, t) => {
    if (["Backspace", "Enter", "Tab", "ArrowLeft", "ArrowRight"].includes(e.key))
      if (e.preventDefault(), e.key === "Backspace") {
        const s = [...o];
        s[t] ? s[t] = "" : t > 0 && (s[t - 1] = "", r(t - 1)), l(s);
      } else e.key === "ArrowLeft" ? r(t - 1) : (e.key === "Enter" || e.key === "ArrowRight" || e.key === "Tab") && [...o][t] !== "" && r(t + 1);
  }, handlePaste: (e) => {
    e.preventDefault();
    const s = e.clipboardData.getData("Text").slice(0, a).split("");
    l([...s, ...Array(a - s.length).fill("")]), r(s.length - 1);
  }, handleChange: (e, t) => {
    const s = e.target.value.slice(-1), n = [...o];
    n[t] = s, l(n), t < a - 1 && s && r(t + 1);
  } };
}, N = ({
  helperTextIcon: a,
  helperTextIconTooltip: f,
  helperText: o = "",
  disabled: l = !1,
  testId: u,
  length: r,
  defaultValues: m,
  status: d,
  autoComplete: w = "off",
  readOnly: e = !1,
  onChange: t,
  ...s
}) => {
  const { values: n, refs: D, handleFocus: A, handleKeydown: j, handlePaste: b, handleChange: F } = K(
    r,
    m
  );
  return k(() => {
    n && (t == null || t(n.join()));
  }, [n]), /* @__PURE__ */ p.jsxs(
    "div",
    {
      className: v(y.fieldContainer, {
        "opacity-disabled": l,
        [y.readOnly]: e
      }),
      children: [
        /* @__PURE__ */ p.jsx(
          "div",
          {
            dir: "ltr",
            className: "flex gap-100",
            children: n.map((h, i) => /* @__PURE__ */ p.jsx(
              "input",
              {
                ...s,
                type: "text",
                value: h,
                maxLength: 1,
                ref: (c) => D.current[i] = c,
                onChange: (c) => F(c, i),
                onClick: () => A(i),
                onKeyDown: (c) => j(c, i),
                onMouseDown: (c) => c.preventDefault(),
                onPaste: b,
                "data-testid": `${u}-${i}`,
                "data-destructive": d === "destructive",
                disabled: l,
                autoComplete: w,
                readOnly: e,
                className: v({ [y.textFilled]: !!h })
              },
              `pinCodeInput-${i}`
            ))
          }
        ),
        (o || a) && /* @__PURE__ */ p.jsx(
          E,
          {
            label: o,
            disabled: l,
            icon: a,
            tooltipText: f,
            status: d,
            withTextField: !0
          }
        )
      ]
    }
  );
};
export {
  N as default
};
//# sourceMappingURL=OtpInput.js.map
